/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Blog_TitleInputs */

const en_meta_blog_title = /** @type {(inputs: Meta_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog — practical guides to useful AI systems | Lindevo`)
};

const lv_meta_blog_title = /** @type {(inputs: Meta_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raksti — praktiski norādījumi par AI sistēmām | Lindevo`)
};

/**
* | output |
* | --- |
* | "Blog — practical guides to useful AI systems \| Lindevo" |
*
* @param {Meta_Blog_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_blog_title = /** @type {((inputs?: Meta_Blog_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Blog_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_blog_title(inputs)
	return en_meta_blog_title(inputs)
});